module.exports = __webpack_public_path__ + "img/2.526c66f2.png";